function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1619",
  "data-name": "Group 1619",
  transform: "translate(-1487.312 -337.076)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4754",
  "data-name": "Path 4754",
  d: "M1505.718,346.115s-2.994,5.615-8.609,5.615-8.609-5.615-8.609-5.615,2.995-5.615,8.609-5.615S1505.718,346.115,1505.718,346.115Z",
  fill: "none",
  stroke: "#a7abad",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_76",
  "data-name": "Ellipse 76",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(1495.609 344.615)",
  strokeWidth: 2,
  stroke: "#a7abad",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "#a7abad"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4778",
  "data-name": "Path 4778",
  d: "M17.219,1.688h0L0,18",
  transform: "translate(1488 336.115)",
  fill: "none",
  stroke: "#a7abad",
  strokeWidth: 1
}));

var SvgEyeShown = function SvgEyeShown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.406,
    height: 17.764,
    viewBox: "0 0 19.406 17.764",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeShown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye_shown.4cf8f2cd.svg";
export { ForwardRef as ReactComponent };